let sliders = {};

$(".swiper-top").each(function() {
  const $this = $(this);
  const numSlides = $this.find("li").length;
  const sliderWidth = numSlides === 3 ? 600 : 800;
  const sliderId = $this.attr('id');
  const sliderSelector = `#${sliderId}`

  // Initialized top slider
  sliders[sliderId] = new Swiper(sliderSelector, {
    loop: false,
    spaceBetween: 10,
    preventClicks: false,
    preventClicksPropagation: false,
    slidesPerView: numSlides,
    breakpoints: {
      320: { spaceBetween: 20 },
      480: { spaceBetween: 20 },
      800: { width: sliderWidth },
    }
  });

  const bottomSliderId = sliderId.replace("top", "bottom");
  const bottomSliderSelector = `#${bottomSliderId}`;

  const navNext = `${bottomSliderSelector} .swiper-button-next`;
  const navPrevious = `${bottomSliderSelector} .swiper-button-prev`;
  const navPagination = `${bottomSliderSelector} .swiper-pagination`;

  // Initialized bottom slider
  sliders[bottomSliderId] = new Swiper(bottomSliderSelector, {
    lazy: false,
    loop: true,
    spaceBetween: 0,
    autoHeight: true,
    threshold: 30,
    navigation: {
      nextEl: navNext,
      prevEl: navPrevious,
    },
    pagination: {
      el: navPagination,
      clickable: true,
    },
    thumbs: {
      swiper: sliders[sliderId],
    },
  });
});
